import { Controller } from "@hotwired/stimulus"

export default class ApplePreviewBaseController extends Controller {
  static targets = [
    "appleCard", "appleHeader", "appleStrip", "appleStripImg", "appleStripNameZone",
    "appleTitle", "appleTitleRow", "appleMemberName", "appleBody", "appleLogoZone", "appleLogoImg",
    "appleField1Label", "appleField1Value", "appleField2Label", "appleField2Value",
    "appleField3Label", "appleField3Value", "appleQr",
    "appleHeaderRight", "appleHeaderRightLabel", "appleHeaderRightValue",
  ]

  applyApplePreview(data) {
    if (!this.hasAppleCardTarget) return
    const bg = data.background_colour || "#fff"
    const fg = data.foreground_colour || "#000"
    const showName = data.show_name_on_apple_card !== false

    this.appleCardTarget.classList.toggle("card-preview--apple-no-name", !showName)
    if (this.hasAppleTitleRowTarget) {
      this.appleTitleRowTarget.classList.toggle("d-none", !showName)
    }

    if (this.hasAppleHeaderTarget) {
      this.appleHeaderTarget.style.backgroundColor = bg
      this.appleHeaderTarget.style.color = fg
      this.appleHeaderTarget.style.borderBottomColor = bg
    }
    if (this.hasAppleBodyTarget) {
      this.appleBodyTarget.style.backgroundColor = bg
      this.appleBodyTarget.style.color = fg
    }
    if (this.hasAppleStripTarget) this.appleStripTarget.style.backgroundColor = bg
    if (this.hasAppleStripNameZoneTarget) this.appleStripNameZoneTarget.style.color = fg
    if (this.hasAppleTitleTarget) this.appleTitleTarget.textContent = data.name || "Card name"
    if (this.hasAppleQrTarget) this.appleQrTarget.style.backgroundColor = bg
    this.setImageFromState(this.appleStripImgTarget, data.images?.strip)
    this.setImageFromState(this.appleLogoImgTarget, data.images?.logo)
    const labelColor = data.label_colour || "#666"
    const valueColor = data.foreground_colour || "#000"
    if (this.hasAppleField1LabelTarget) this.appleField1LabelTarget.style.color = labelColor
    if (this.hasAppleField1ValueTarget) this.appleField1ValueTarget.style.color = valueColor
    if (this.hasAppleField2LabelTarget) this.appleField2LabelTarget.style.color = labelColor
    if (this.hasAppleField2ValueTarget) this.appleField2ValueTarget.style.color = valueColor
    if (this.hasAppleField3LabelTarget) this.appleField3LabelTarget.style.color = labelColor
    if (this.hasAppleField3ValueTarget) this.appleField3ValueTarget.style.color = valueColor
    if (this.hasAppleHeaderRightLabelTarget) this.appleHeaderRightLabelTarget.style.color = labelColor
    if (this.hasAppleHeaderRightValueTarget) this.appleHeaderRightValueTarget.style.color = valueColor
  }

  setImageSource(imgEl, url, file, previewDataUrl) {
    if (!imgEl) return
    this.releaseObjectUrl(imgEl)
    if (previewDataUrl) {
      imgEl.src = previewDataUrl
      this.showImage(imgEl)
      return
    }
    if (file) {
      const objectUrl = URL.createObjectURL(file)
      imgEl.dataset.objectUrl = objectUrl
      imgEl.src = objectUrl
      this.showImage(imgEl)
      return
    }
    if (url) {
      imgEl.src = url
      this.showImage(imgEl)
      return
    }
    this.hideImage(imgEl)
  }

  setImageFromState(imgEl, imageState) {
    const state = imageState || {}
    this.setImageSource(imgEl, state.url || null, state.file || null, state.previewDataUrl || null)
  }

  showImage(imgEl) {
    imgEl.classList.remove("d-none")
    imgEl.style.display = ""
  }

  hideImage(imgEl) {
    imgEl.removeAttribute("src")
    imgEl.classList.add("d-none")
    imgEl.style.display = ""
  }

  releaseObjectUrl(imgEl) {
    const objectUrl = imgEl?.dataset?.objectUrl
    if (objectUrl) {
      URL.revokeObjectURL(objectUrl)
      delete imgEl.dataset.objectUrl
    }
  }

  releaseObjectUrls() {
    this.element.querySelectorAll("img[data-object-url]").forEach((img) => {
      this.releaseObjectUrl(img)
    })
  }
}
